export const savePercent = ({savedPercentValue = '', monthlyPrice, annualPrice}) => {
  if (savedPercentValue) return savedPercentValue;

  const month = Number(monthlyPrice);
  const annual = Number(annualPrice);

  if (!Number.isFinite(month) || !Number.isFinite(annual) || month <= 0 || annual <= 0) {
    return null;
  }

  const yearlyCost = month * 12;
  const saved = yearlyCost - annual;

  if (saved <= 0) {
    return null;
  }

  const percent = Math.floor((saved / yearlyCost) * 100);

  return percent > 0 ? `${percent}%` : null;
}
